import {SOPostReport} from '../../core/report/so-post-report';
import {ReportCore} from './report.core';
import {SOGetReport} from '../../core/report/so-get-report';
import {FormField, SelectionOption} from 'lionheartland';
import {postReportFormFieldOptions} from './post-report-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {PeriodCore} from '../period/period.core';
import {SOGetPeriod} from '../../core/period/so-get-period';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostReport extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postReportFormFieldOptions);

  RequestClass = SOPostReport

  constructor(
    public entityCore: ReportCore
  ) {
    super();
    if (postReportFormFieldOptions.period) {
      postReportFormFieldOptions.period.makeCore = true;
    }
    if (postReportFormFieldOptions.project) {
      postReportFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('active'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'period',
        SOGetPeriod,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}